import { createContext, useContext, type ReactNode } from "react";
export const NeckDiagramStudentContext = createContext({ studentId: null as string | null, leftHanded: false, pending: false, error: null as string | null, activate: () => {}, retry: () => {} });
const PlaybackContext = createContext(false);
export const useNeckDiagramPlayback = () => useContext(PlaybackContext);
export function NeckDiagramPlaybackProvider({ enabled, children }: { enabled: boolean; children: ReactNode }) {
  return <PlaybackContext.Provider value={enabled}>{children}</PlaybackContext.Provider>;
}
